"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenuController = exports.ExportMenuControllerImpl = void 0;
const tslib_1 = require("tslib");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const export_notification_1 = require("../export.notification/export.notification");
const export_notification_ctrl_1 = require("../export.notification/export.notification.ctrl");
const export_notification_style_1 = require("../export.notification/export.notification.style");
const ReportMaker_1 = require("../report/ReportMaker");
class ExportMenuControllerImpl {
    hasOCalcForm(collectionSummaries) {
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null) {
                return true;
            }
        }
        return false;
    }
    hasSPIDACalcForm(collectionSummaries) {
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null) {
                return true;
            }
        }
        return false;
    }
    hasPoleforeman(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.poleforeman) {
                return true;
            }
        }
        return false;
    }
    hasIkePoleForeman(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) {
                return true;
            }
        }
        return false;
    }
    hasDDS(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.dds) {
                return true;
            }
        }
        return false;
    }
    exportKML() {
        const selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.kml(selectorsByTag).then((result) => {
            if (result == null) {
                return;
            }
            if (result.notifications != null && result.notifications.length > 0) {
                notification_service_1.NotificationService.warn({ key: i18n_1.T.EXPORT_NOT_EVERYTHING_EXPORTED });
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    }
    exportExcel() {
        const selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.excel(selectorsByTag).then((result) => {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    }
    exportImportableExcel() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield services_1.Services.Export.importableExcel(this.getSelectorsByTag());
            if (result == null) {
                return null;
            }
            return this.downloadExportResult(result);
        });
    }
    exportJSON() {
        const selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.json(selectorsByTag).then((result) => {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    }
    /**
     * Creates a PDF report of collections and downloads it
     * @param type The type of report to export
     */
    exportReport(type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = page_state_1.CurrentState.Tag.collections.map((summary) => summary.revision);
            const collectionModels = yield Promise.all(revisions.map((revision) => store_1.AppStore.Collection.fetch(revision)));
            return ReportMaker_1.PDFReportMaker.makeReport(type, collectionModels);
        });
    }
    exportOCalc() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const selectorsByTag = this.getSelectorsByTag((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null;
            });
            const response = yield services_1.Services.Export.ocalc(selectorsByTag);
            if (response == null) {
                return null;
            }
            return this.downloadExportResult(response);
        });
    }
    exportSPIDACalc(noPhotos) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const selectorsByTag = this.getSelectorsByTag((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null;
            });
            const response = yield services_1.Services.Export.spidacalc(selectorsByTag, noPhotos);
            if (response == null) {
                return null;
            }
            return this.downloadExportResult(response);
        });
    }
    exportPoleforeman() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const selectorsByTag = this.getSelectorsByTag((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.poleforeman != null;
            });
            const response = yield services_1.Services.Export.poleforeman(selectorsByTag);
            if (response == null) {
                return null;
            }
            return this.downloadExportResult(response);
        });
    }
    exportIkePoleForeman() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            const collectionSummaries = [];
            for (const summary of page_state_1.CurrentState.Tag.collections) {
                const formSummary = yield store_1.AppStore.FormSummary.getAsync(summary.formRevision);
                if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) {
                    collectionSummaries.push(summary);
                }
            }
            const selectorsByTag = this.getSelectorsByTagForSummaries(collectionSummaries);
            const response = yield services_1.Services.Export.ikePoleForeman(selectorsByTag);
            if (response == null) {
                return null;
            }
            return this.downloadExportResult(response);
        });
    }
    exportDDS() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const selectorsByTag = this.getSelectorsByTag();
            const response = yield services_1.Services.Export.dds(selectorsByTag);
            if (response == null) {
                return null;
            }
            return this.downloadExportResult(response);
        });
    }
    exportImageZip() {
        const selectorsByTag = this.getSelectorsByTag();
        return services_1.Services.Export.imageZip(selectorsByTag).then((result) => {
            if (result == null) {
                return;
            }
            if (result.url != null) {
                services_1.Services.Download.download(result.url);
            }
        });
    }
    runExport(exportState, func) {
        return Promise.resolve()
            .then((_) => exportState.setExporting(true))
            .then((_) => func())
            .catch((_) => notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL }))
            .then((_) => exportState.setExporting(false));
    }
    downloadExportResult(response) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const exportNotificationCtrl = new export_notification_ctrl_1.ExportNotificationCtrl(response.notifications);
            const revisionsToFetch = exportNotificationCtrl.getRevisions();
            if (revisionsToFetch.length === 0) {
                services_1.Services.Download.download(response.url, response.fileName);
                return null;
            }
            const collectionPromises = revisionsToFetch.map((revision) => store_1.AppStore.Collection.fetch(revision));
            const collections = yield Promise.all(collectionPromises);
            yield this.showExportNotifications(exportNotificationCtrl, collections);
            if (!exportNotificationCtrl.errors && response.url != null) {
                services_1.Services.Download.download(response.url, response.fileName);
            }
        });
    }
    showExportNotifications(exportNotificationCtrl, collections) {
        exportNotificationCtrl.setCollections(collections);
        const modalContext = {
            title: export_notification_1.ExportNotificationTitle.view(exportNotificationCtrl),
            content: export_notification_1.ExportNotificationContent.view(exportNotificationCtrl),
            hasCancel: false,
            className: export_notification_style_1.CSS.modal,
        };
        return modal_service_1.ModalService.open(modalContext);
    }
    /**
     * @deprecated Use {@link getSelectorsByTagForSummaries} instead to allow caller to use async filtering.
     */
    getSelectorsByTag(filter = () => true) {
        var selectorsByTag = {};
        for (const collectionSummary of page_state_1.CurrentState.Tag.collections) {
            if (filter(collectionSummary)) {
                const selector = { uuid: collectionSummary.uuid };
                const tagId = collectionSummary.tags[0];
                if (!tagId) {
                    continue;
                }
                if (selectorsByTag[tagId]) {
                    selectorsByTag[tagId].push(selector);
                }
                else {
                    selectorsByTag[tagId] = [selector];
                }
            }
        }
        return selectorsByTag;
    }
    getSelectorsByTagForSummaries(collectionSummaries) {
        var selectorsByTag = {};
        for (const collectionSummary of collectionSummaries) {
            const selector = { uuid: collectionSummary.uuid };
            const tagId = collectionSummary.tags[0];
            if (!tagId) {
                continue;
            }
            if (selectorsByTag[tagId]) {
                selectorsByTag[tagId].push(selector);
            }
            else {
                selectorsByTag[tagId] = [selector];
            }
        }
        return selectorsByTag;
    }
}
exports.ExportMenuControllerImpl = ExportMenuControllerImpl;
exports.ExportMenuController = new ExportMenuControllerImpl();
//# sourceMappingURL=export.menu.ctrl.js.map